<template>
  <div class="eng-status">
    <div class="title">
      <span class="title__h3">{{
        this.$lange == "en" ? "Overview of Engineer Status" : "工程师状态"
      }}</span>
      <span class="title__tip"
        >({{ $lange == "en" ? "Real-time" : "实时更新" }})</span
      >
    </div>
    <div class="graph graph_flex">
      <div class="graph_table">
        <el-table size="mini" :data="statusData" border>
          <el-table-column
            prop="type"
            :label="$lange == 'en' ? 'Status' : '状态'"
            min-width="100px"
          >
            <template slot-scope="scope">
              <span>{{ employStatusCode[scope.row.type] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="c in codes"
            :key="c.id"
            :prop="enc(c.code)"
            :label="saveName(c)"
            min-width="90px"
          ></el-table-column>
        </el-table>
      </div>
      <div class="chart">
        <e-charts
          style="width: 100%"
          :options="statusOption"
          auto-resize
        ></e-charts>
      </div>
    </div>
  </div>
</template>

<script>
import theme from "../graph/theme";
import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";

export default {
  name: "EngineerStatus",
  components: { ECharts },
  props: {
    codes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rawData: [],
      statusData: [],
      employStatusCode: {
        travelling: this.$lange == "en" ? "On Site" : "外出",
        availability: this.$lange == "en" ? "Available" : "可派",
        vacation: this.$lange == "en" ? "On Leave" : "休假",
      },
    };
  },
  async created() {
    try {
      await this.fetchEngineerStatus();
    } catch (e) {
      this.$message.error(e.response.data.message);
    }
  },
  computed: {
    codeMap() {
      return this.codes.reduce((pre, cur) => {
        pre[encodeURIComponent(cur.code)] = cur.title;
        return pre;
      }, {});
    },

    statusOption() {
      const legendData = this.codes.map((i) => this.saveName(i));
      const series = this.statusData.map((data) => {
        const { type, ...rest } = data;
        // const seriesData = Object.keys(rest).map((k) => ({
        //   name: this.codeMap[k],
        //   value: rest[k],
        // }));
        const seriesData = this.codes.map((code) => ({
          name: this.codeMap[encodeURIComponent(code.code)],
          value: rest[encodeURIComponent(code.code)] || 0,
        }));
        return {
          name: this.employStatusCode[type],
          type: "bar",
          data: seriesData,
          label: {
            show: true,
            position: "top",
            formatter: (params) => (params.value ? params.value : ""),
          },
        };
      });
      return {
        ...theme,
        legend: {
          top: 6,
          left: 32,
        },
        grid: {
          left: 32,
          right: 46,
          containLabel: true,
          show: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: legendData,
        },
        yAxis: {
          type: "value",
        },
        series,
      };
    },
  },
  methods: {
    saveName(data) {
      if (this.$lange == "en") {
        if (data.extraData && data.extraData.en) {
          return data.extraData.en;
        }
        return data.title;
      } else {
        return data.title;
      }
    },
    enc(val) {
      return encodeURIComponent(val);
    },
    /**
     * 数据处理-方便表格展示
     * [
     *  {code: 'electric', travelling: 1, availability: 2, vacation: 3 },
     *  {code: 'mechanic', travelling: 11, availability: 22, vacation: 33 },
     * ]
     * 处理成：
     * [
     *  { type: 'travelling', 'electric': 1, 'mechanic': 11 },
     *  { type: 'availability', 'electric': 2, 'mechanic': 22 },
     *  { type: 'vacation', 'electric': 3, 'mechanic': 33 },
     * ]
     */
    filterStatusData(rawData) {
      let newData = {};
      rawData.forEach((data) => {
        Object.keys(this.employStatusCode).forEach((type) => {
          if (newData[type]) {
            newData[type][encodeURIComponent(data.code)] = data[type];
          } else {
            newData[type] = { [encodeURIComponent(data.code)]: data[type] };
          }
        });
      });
      return Object.keys(newData).map((type) => ({ ...newData[type], type }));
    },

    async fetchEngineerStatus() {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/report/employeeStatusCount",
        {},
        "GET"
      );
      this.rawData = Object.freeze(res);
      this.statusData = this.filterStatusData(this.rawData);
    },
  },
};
</script>

<style lang="scss" scoped>
.eng-status {
  /* max-width: 800px; */
  box-sizing: border-box;
}
.el-table {
  border: 1px solid #aaa7a788;
  font-size: 14px;
}

.title {
  border-bottom: 1px solid #e4e4e4;
  padding: 10px 20px;
}
.title__h3 {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  margin-right: 8px;
}
.title__tip {
  color: #ccc;
}

.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #aaa7a788;
  border-right: 1px solid #aaa7a788;
}

.graph_flex {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

.graph_table {
  width: 465px;
}

.chart {
  /* width: 600px; */
  width: calc(100% - 473px);
  /* margin-top: 16px; */
  margin-left: 8px;
  border: 1px solid #aaa7a788;
}

.graph {
  margin-top: 16px;
  padding: 8px;
}
</style>
